
import Vue from 'vue'

interface IData {}

export default Vue.extend({
  props: {
    cubeText: {
      type: String,
      required: true
    },
    color: {
      type: String,
      required: false,
      default: 'background-shades-white'
    }
  },
  data(): IData {
    return {}
  }
})
